import type { PPProviderBehavior } from '../types';
import { CISConfigType } from '../../typegen/cis-config-type';

export const invoiceCloudV2PPBehavior: PPProviderBehavior = {
	label: 'InvoiceCloud V2',
	requiresPrepareTransaction: false,
	cardPrepareAutoStart: false,
	getCashInvoiceGuid(item) {
		return item.itemGuid || null;
	},
	getReceiptInvoiceNumber(item, _cartId, obscure) {
		if (item.itemGuid) return item.itemGuid;
		return obscure ? (item.obscuredItemNumber ?? item.itemNumber) : item.itemNumber;
	},
	getTestPanelConfig(cisType) {
		return {
			show: cisType !== CISConfigType.InvoiceCloudV1 && cisType !== CISConfigType.InvoiceCloudV2,
			altText: 'InvoiceCloud',
		};
	},
	cardDeviceDisplayName: 'MagTek',
	requiresPayorInformation: false,
};
